<textarea
  class="notes-input"
  [ngModel]="value"
  (ngModelChange)="onInputChange($event)"
  [placeholder]="placeholder"
  [attr.autofocus]="autofocus ? '' : null"
  cdkTextareaAutosize
  [cdkAutosizeMinRows]="minRows">
</textarea>
